import type { CmdbView } from '../api/cmdb'

/**
 * Cele patru vederi ale CMDB-ului, ca o banda in capul fiecareia -
 * `application/views/version-3/inventoree/_views.php`.
 *
 * Erau intrari in bara modulului, ceea ce se citea ca patru subiecte cand e
 * unul singur: elementele de configurare si ce e adevarat despre ele. Raman
 * pagini separate - fiecare poarta un tabel prea mare ca sa incapa langa
 * celelalte - dar se ajunge la ele de aici, si fiecare poarta un rand care
 * spune la ce raspunde. O fila cu un singur cuvant pe ea nu spune niciodata
 * cui i se cuvine intrebarea cu care omul a venit.
 *
 * PE CARE ECRANE STA
 *
 * Pe cele pe care o incarca si portalul: `cmdb/index.php` si
 * `cmdb/health/index.php`, plus cele trei machete de mentenanta. NU pe
 * fotografii (`cmdb/baseline/index.php` si `compare.php`) si nu pe fisa unui
 * element - acolo portalul n-o randeaza, desi banda stie sa aprinda "State".
 * Golul e al portalului; nu se umple aici, fiindca atunci cele doua ar arata
 * altfel exact in locul in care omul s-a plans ca difera.
 *
 * `current` e calea vederii care e deschisa, in aceeasi forma ca `url`.
 *
 * `<a href>`, nu `<Link>`: asa deseneaza si bara modulului din `Shell`, iar
 * caile de aici vin de la server, nu din tipurile ruterului.
 */
export function CmdbViews({ views, current }: { views: CmdbView[]; current: string }) {
  if (views.length === 0) return null

  return (
    <ul className="adm-views">
      {views.map((view) => (
        <li key={view.url} className={current === view.url ? 'active' : undefined}>
          <a href={`/app/${view.url}`}>
            <span className="adm-view-label">
              <i className={`fas ${view.icon}`}></i> {view.label}
            </span>
            <span className="adm-view-note">{view.note}</span>
          </a>
        </li>
      ))}
    </ul>
  )
}
